import { isAxiosError } from "axios";
import { toast } from "react-toastify";

/**
 *
 * @param {Error} error
 * @returns
 */
export default function validationErrorForPromise(error) {
  if (
    isAxiosError(error) &&
    error.response?.data?.message === "Validation Error" &&
    Array.isArray(error.response?.data?.errors)
  ) {
    error.response.data.errors.forEach((element) => {
      if (typeof element === "string") toast.warn(element);
    });
  }
  throw error;
}
